import {Brick, registerBrick, ErrorFlow} from 'olympe';

export default class GetURLFromIframeOnLoadEvent extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} event
     * @param {function(string)} setURL
     * @param {function(ErrorFlow)} setErrorFlow
     */
    update($, [event], [setURL, setErrorFlow]) {
        try {
            setURL(event?.target?.contentWindow?.location?.href || '');
        } catch (e) {
            setErrorFlow(ErrorFlow.create(`Cannot get URL: ${e}`, 1));
        }
    }
}

registerBrick('0190968ddcbb96102c7b', GetURLFromIframeOnLoadEvent);
